import React, { useCallback, useEffect, useState } from 'react';
import { Link, NavLink, useHistory } from 'react-router-dom';
import { Container, Col, Row, Form, Modal, Image } from 'react-bootstrap';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../../Assets/css/productlist.css';
import OwlCarousel from 'react-owl-carousel';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';
import Slider from 'react-slick';
import axios from 'axios';
import { base_url, currency, postHeader } from '../../Helpers/request';
import { Helmet } from 'react-helmet';
import { Skeleton, Radio } from '@mui/material';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa6';
const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  centerMode: false,
  nextArrow: <FaChevronRight />,
  prevArrow: <FaChevronLeft />,
};

const SingleTennisBracelet = ({ prod, idx }) => {
  const [selectedVariant, setSelectedVariant] = useState({
    name: prod?.name ?? '',
    product_id: prod?.product_id ?? '',
    slug: prod?.slug ?? '',
    group_id: prod?.variant_id ?? '',
    sale_price: prod?.sale_price ?? '',
    image: prod?.image ?? '',
    product_carat_weight: prod?.product_carat_weight ?? '',
    carat_weight: prod?.carat_weight ?? [],
    metal_color: prod?.metal_color ?? '',
    metal_group: prod?.metal_group ?? [],
  });

  const handleFilters = ({ type, val }) => {
    if (type === 'metal_color') {
      setSelectedVariant({
        ...selectedVariant,
        [type]: val,
      });
    } else {
      setSelectedVariant({
        ...selectedVariant,
        product_carat_weight: val,
      });
    }

    fetchFilters({ type, val });
  };

  const fetchFilters = useCallback(
    async ({ type, val }) => {
      let obj = {
        metal_color: selectedVariant?.metal_color,
        carat_weight: selectedVariant?.product_carat_weight,
        group_id: selectedVariant.group_id,
        product_id: selectedVariant.product_id,
      };

      if (type === 'metal_color') {
        obj = { ...obj, [type]: val };
      } else {
        obj = { ...obj, carat_weight: val };
      }

      await axios
        .post(base_url + '/product/getfilterbracelets', obj, {
          headers: postHeader,
        })
        .then((r) => {
          if (r.data.status == 1) {
            setSelectedVariant({
              ...selectedVariant,
              name: r.data.data?.name ?? '',
              product_id: r.data.data?.product_id ?? '',
              slug: r.data.data?.slug ?? '',
              group_id: r.data.data?.variant_id ?? '',
              sale_price: r.data.data?.sale_price ?? '',
              image: r.data.data?.image ?? '',
              product_carat_weight: r.data.data?.product_carat_weight ?? '',
              //carat_weight: r.data.data?.carat_weight ?? [],
              metal_color: r.data.data?.metal_color ?? '',
              //metal_group: r.data.data?.metal_group ?? [],
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    [selectedVariant],
  );

  return (
    <Col lg={4} key={idx}>
      <div className="bracelet-item">
        <div className="product-thumb">
          <Link to={`/productdetail/${selectedVariant?.slug}`}>
            <div className="img-box">
              <div className="img-box-overlay"></div>
              <img src={selectedVariant?.image} alt="" />
            </div>
          </Link>
        </div>
        <div className="product-info">
          <Link to={`/productdetail/${selectedVariant?.slug}`} className="product_name">
            {selectedVariant?.name}
          </Link>

          <div className="br_metal_type">
            <h6 className="m-0">
              <span>Metal</span>
            </h6>
            <ul className="nav nav-tabs">
              {selectedVariant?.metal_group?.map((m, mId) => (
                <li className={`${m === '14K-Rose-Gold' ? 'rose_goldbx' : m === '14K-White-Gold' ? 'white_goldbx' : m === '14K-Yellow-Gold' ? 'yellow_goldbx' : 'platnium_plbx'}`}>
                  <Radio
                    className={`input-wrapper ${m === '14K-Rose-Gold' ? 'rose_gold' : m === '14K-White-Gold' ? 'white_gold' : m === '14K-Yellow-Gold' ? 'yellow_gold' : 'platnium_pl'}`}
                    type="radio"
                    name="metal_color_filter"
                    value={m}
                    onChange={() => {
                      // setSelectedVariant({
                      //   ...selectedVariant,
                      //   metal_color: m,
                      // });
                      handleFilters({ type: 'metal_color', val: m });
                    }}
                    checked={selectedVariant?.metal_color === m}
                  />
                  <span className={` ${m === '14K-Rose-Gold' ? 'rose_gold' : m === '14K-White-Gold' ? 'white_gold' : m === '14K-Yellow-Gold' ? 'yellow_gold' : 'platnium_pl'} ${selectedVariant?.metal_color === m ? 'active' : ''}`}>{m.charAt(0) + m?.charAt(1)}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="br_carat_type">
            <h6 className="m-0">
              <span>Carat</span>
            </h6>

            <div className="slider-wrapper-cart">
              {selectedVariant?.carat_weight?.length ? (
                <Slider className="carat_slider" {...settings}>
                  {selectedVariant?.carat_weight?.map((ct, index) => (
                    <div className={`carat ${selectedVariant?.metal_color === ct ? 'active' : ''}`} key={index}>
                      <Radio
                        className="carat-input-wrapper"
                        value={ct}
                        checked={ct === selectedVariant?.product_carat_weight}
                        onChange={() => {
                          // setSelectedVariant({
                          //   ...selectedVariant,
                          //   product_carat_weight: ct,
                          // });
                          handleFilters({
                            type: 'carat_weight',
                            val: ct,
                          });
                        }}
                      />
                      {ct}
                    </div>
                  ))}
                </Slider>
              ) : null}
            </div>
          </div>
          <div className="product-price title14 play-font">
            <ins className="black title18">
              {currency}
              {selectedVariant?.sale_price}
            </ins>
          </div>
        </div>
      </div>
    </Col>
  );
};

const TennisBraceletsList = () => {
  const [loader, setLoader] = useState(true);
  const [listdata, setListdata] = useState([]);
  const [listTitle, setListTitle] = useState('');
  const [metaDetails, setMetaDetails] = useState('');

  const getList = useCallback(() => {
    axios
      .get(base_url + '/product/bracelet_collection')
      .then((res) => {
        if (res.data.status == 1) {
          setLoader(false);
          setListdata(res.data.data);
          setMetaDetails({
            title: res.data?.meta_title ?? '',
            description: res.data?.meta_description ?? '',
            keywords: res.data?.meta_keywords ?? ' ',
          });
          //   setListTitle(res.data.data?.title);
          //setCatediscription(res.data?.meta_description);
          //setMetacatediscription(res.data.data?.meta_description);
          //   setCatekeyword(res.data.data?.meta_keywords);
          //   setCatetitle(res.data.data?.meta_title);
          //   setProductCount(res.data.data?.count);
          //   var count = (res.data.data?.count / 18).toFixed();
          //   if (count * 18 >= res.data.data?.count) {
          //     setPageCount(count);
          //   } else {
          //     setPageCount(Number(count) + 1);
          //   }
          //   if (res.data.data?.count == 0) {
          //     setShowFilter(false);
          //   } else {
          //     setShowFilter(true);
          //   }
        } else if (res.data.status == 2) {
          //   localStorage.removeItem ("bw-user");
          //   dispatch (whishlistlength(0));
          //   dispatch(cartlengthvalue(0));
          //   dispatch(sessionId(""));
          //   history.push("/");
          //   window.location.reload(true);
        } else {
          setListdata([]);
          setLoader(false);
          //   setProductCount(0);
          //   setPageCount(0);
          //toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    getList();
  }, [getList]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails?.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
      </Helmet>
      <div className="rcs_product_list_main">
        <Container className="rcs_customer_container rcs_large_container mt-3">
          <Row>
            <Col sm={12} className="p-md-0">
              <div className="rcs_bread_crumb">
                {/* breadcrumb start here */}
                {/* <div role="presentation" onClick={handleClick}>
                  <Col className="rcs_breadcrumb mb-2 p-0">
                    <Breadcrumbs aria-label="breadcrumb">
                      <NavLink underline="hover" color="inherit" to="/">
                        Home
                      </NavLink>
                      <Typography color="text.primary">
                        {paramid?.charAt(0).toUpperCase() +
                          paramid.slice(1).replace("-", " ")}
                      </Typography>
                    </Breadcrumbs>
                  </Col>
                </div> */}
                <div className="rcs_category_title">
                  {/* <div className="d-flex align-items-start pt-10">
                                        <div className="grid-item-title text-dark w-100">Cushion Shaped Halo Diamond Ring in 18kt White and Rose Gold</div>
                                    </div> */}
                  <h1>{listTitle?.length ? listTitle : 'Tennis Bracelets'}</h1>
                  {/* {loader ? (
                    <Skeleton
                      variant="text"
                      animation="wave"
                      className="mb-4"
                      width={"100%"}
                      height={24}
                    />
                  ) : (
                    <p>{catediscription}</p>
                  )} */}
                </div>
              </div>
            </Col>
          </Row>
          <div className="rcs_product_grid bracelets-list-wrapper">
            <Row>
              {loader ? (
                Array.from(new Array(6)).map((_, i) => (
                  <Col lg={4} key={i}>
                    <Skeleton animation="wave" className="m-0" width={'100%'} height={350} />
                  </Col>
                ))
              ) : listdata?.length ? (
                listdata?.map((prod, idx) => <SingleTennisBracelet prod={prod} idx={idx} />)
              ) : (
                <>No Data Available</>
              )}
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default TennisBraceletsList;
